/**
 * created by mgg
 *获取抖音链接方式
 */
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {Scrollbars} from "react-custom-scrollbars";
import {Modal} from "antd";

export default class DouYinLink extends Component {
    static defaultProps = {};
    static propTypes = {};

    constructor(props) {
        super(props);
        this.state = {}
    }

    componentWillMount() {
    }

    componentDidMount() {
    }

    render() {
        return (
            <div style={{height: window.innerHeight - 90,paddingBottom:'20px'}}>
                <div style={{
                    width: '100%', height: '120px', background: "#0050b3",
                    color: '#ffffff',
                    fontSize: '30px',
                    textAlign: "center",
                    lineHeight: '120px'

                }}>抖音链接添加教程
                </div>
                <Scrollbars>
                    <div style={{backgroundColor: "#fff",display:"flex",justifyContent:"space-around",padding:"20px 0px"}} className={"douYinLinkPic"}>
                        <div style={{width:259}}>
                            <div style={{
                                fontWeight: "bold",
                                fontSize: 16,
                                color: "rgba(0, 0, 0, 0.85)",
                                opacity: 1,
                                marginBottom:8
                            }}>第一步
                            </div>
                            <div style={{
                                fontWeight: "bold",
                                fontSize: 14,
                                color: "rgba(0, 0, 0, 0.65)",
                                opacity: 1,
                                height: 30,
                                marginBottom:39
                            }}>进入抖音APP后点击搜索
                            </div>
                            <img src={"images/1.png"} style={{width:"100%"}}/>
                        </div>
                        <div style={{width:259}}>
                            <div style={{
                                fontWeight: "bold",
                                fontSize: 16,
                                color: "rgba(0, 0, 0, 0.85)",
                                opacity: 1,
                                marginBottom:8
                            }}>第二步
                            </div>
                            <div style={{
                                fontWeight: "bold",
                                fontSize: 14,
                                color: "rgba(0, 0, 0, 0.65)",
                                opacity: 1,
                                height: 30,
                                marginBottom:39
                            }}>输入您要添加的抖音账号的名称并进行搜索（如下图）
                            </div>
                            <img src={"images/2.png"} style={{width:"100%"}}/>
                        </div>
                        <div style={{width:259}}>
                            <div style={{
                                fontWeight: "bold",
                                fontSize: 16,
                                color: "rgba(0, 0, 0, 0.85)",
                                opacity: 1,
                                marginBottom:8
                            }}>第三步
                            </div>
                            <div style={{
                                fontWeight: "bold",
                                fontSize: 14,
                                color: "rgba(0, 0, 0, 0.65)",
                                opacity: 1,
                                height: 30,
                                marginBottom:39
                            }}>点击账号查看账号主页（如下图）
                            </div>
                            <img src={"images/3.png"} style={{width:"100%"}}/>
                        </div>
                        <div style={{width:259}}>
                            <div style={{
                                fontWeight: "bold",
                                fontSize: 16,
                                color: "rgba(0, 0, 0, 0.85)",
                                opacity: 1,
                                marginBottom:8
                            }}>第四步
                            </div>
                            <div style={{
                                fontWeight: "bold",
                                fontSize: 14,
                                color: "rgba(0, 0, 0, 0.65)",
                                opacity: 1,
                                height: 30,
                                marginBottom:39
                            }}>点击账号主页右上角 "更多" 按钮（如下图）
                            </div>
                            <img src={"images/4.png"} style={{width:"100%"}}/>
                        </div>
                    </div>
                    <div style={{backgroundColor: "#fff",display:"flex",justifyContent:"space-around",padding:"20px 0px"}} className={"douYinLinkPic"}>
                        <div style={{width:259}}>
                            <div style={{
                                fontWeight: "bold",
                                fontSize: 16,
                                color: "rgba(0, 0, 0, 0.85)",
                                opacity: 1,
                                marginBottom:8
                            }}>第五步
                            </div>
                            <div style={{
                                fontWeight: "bold",
                                fontSize: 14,
                                color: "rgba(0, 0, 0, 0.65)",
                                opacity: 1,
                                height: 30,
                                marginBottom:39
                            }}>点击下方弹框中的 "分享主页" 按钮（如下图）
                            </div>
                            <img src={"images/5.png"} style={{width:"100%"}}/>
                        </div>
                        <div style={{width:259}}>
                            <div style={{
                                fontWeight: "bold",
                                fontSize: 16,
                                color: "rgba(0, 0, 0, 0.85)",
                                opacity: 1,
                                marginBottom:8
                            }}>第六步
                            </div>
                            <div style={{
                                fontWeight: "bold",
                                fontSize: 14,
                                color: "rgba(0, 0, 0, 0.65)",
                                opacity: 1,
                                height: 30,
                                marginBottom:39
                            }}>点击 "复制链接" 按钮（如下图）
                            </div>
                            <img src={"images/6.png"} style={{width:"100%"}}/>
                        </div>
                        <div style={{width:259}}>
                            <div style={{
                                fontWeight: "bold",
                                fontSize: 16,
                                color: "rgba(0, 0, 0, 0.85)",
                                opacity: 1,
                                marginBottom:8
                            }}>第七步
                            </div>
                            <div style={{
                                fontWeight: "bold",
                                fontSize: 14,
                                color: "rgba(0, 0, 0, 0.65)",
                                opacity: 1,
                                height: 30,
                                marginBottom:39
                            }}>复制成功（如下图）
                            </div>
                            <img src={"images/7.png"} style={{width:"100%"}}/>
                        </div>
                        <div style={{width:259}}>
                            <div style={{
                                fontWeight: "bold",
                                fontSize: 16,
                                color: "rgba(0, 0, 0, 0.85)",
                                opacity: 1,
                                marginBottom:8
                            }}>第八步
                            </div>
                            <div style={{
                                fontWeight: "bold",
                                fontSize: 14,
                                color: "rgba(0, 0, 0, 0.65)",
                                opacity: 1,
                                height: 30,
                                marginBottom:39
                            }}>使用微信等工具发送至电脑端再复制进行新媒体矩阵即可将抖音链接添加完成（如下图）
                            </div>
                            <img src={"images/8.png"} style={{width:"100%"}}/>
                        </div>
                    </div>
                    {/*<style>{`.douYinLinkPic img{width: 180px;height: 391px;object-fit: cover;}`}</style>*/}
                </Scrollbars>
            </div>
        )
    }
}
